var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    id: "Moon-Stars--Streamline-Plump.svg",
    height: 30,
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Moon Stars Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "moon-stars--night-time"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#a2a2a5",
    d: "M12.4435 4.7739375C5.7368125 4.7739375 0.3 10.210749999999999 0.3 16.917375S5.7368125 29.060875 12.4435 29.060875C17.483 29.060875 21.8034375 25.991187500000002 23.641125000000002 21.623437499999998C23.9161875 20.969625 23.7011875 20.3228125 23.2994375 19.92275C22.912125 19.53725 22.320937500000003 19.3383125 21.7211875 19.4823125C21.126875 19.625 20.50575 19.7008125 19.8655 19.7008125C15.494062500000002 19.7008125 11.95025 16.157 11.95025 11.785499999999999C11.95025 10.001999999999999 12.539 8.35875 13.533124999999998 7.035749999999999C13.862749999999998 6.597125 13.8945 6.047687499999999 13.704875000000001 5.6074375C13.509625 5.1541250000000005 13.054375 4.7739375 12.4435 4.7739375Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fill: "#bababd",
    d: "M24.7460625 6.4534375C24.2898125 5.06625 22.3275625 5.06625 21.871375 6.4534375L20.90275 9.3984375L17.957749999999997 10.366999999999999C16.570625 10.82325 16.570625 12.7855 17.957749999999997 13.2416875L20.90275 14.2103125L21.871375 17.15525C22.3275625 18.5424375 24.2898125 18.5424375 24.7460625 17.15525L25.714624999999998 14.2103125L28.659625000000002 13.2416875C30.0468125 12.7855 30.0468125 10.82325 28.659625000000002 10.366999999999999L25.714624999999998 9.3984375L24.7460625 6.4534375Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    fill: "#bababd",
    d: "M18.834812499999998 1.8978125000000001C18.834812499999998 1.368375 18.4055625 0.939125 17.8760625 0.939125S16.917375 1.368375 16.917375 1.8978125000000001V2.8565H15.9586875C15.429250000000001 2.8565 15 3.28575 15 3.8151875000000004S15.429250000000001 4.773875 15.9586875 4.773875H16.917375V5.7326250000000005C16.917375 6.2620625 17.346625 6.6913124999999996 17.8760625 6.6913124999999996S18.83475 6.2620625 18.83475 5.7326250000000005V4.7739375H19.793499999999998C20.322937500000002 4.7739375 20.752187499999998 4.3446875 20.752187499999998 3.8151875000000004S20.322937500000002 2.8565 19.793499999999998 2.8565H18.834812499999998V1.8978125000000001Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.18a95deb482d2a0f70f2f73b766f1801.svg";
export { ForwardRef as ReactComponent };